import React, {useEffect, useState} from "react";
import useLlmConfig from "@/query/llmConfig/useLlmConfig";
import {LlmConfig} from "@/model/llmSpecification";
import LlmProviderSettingForm from "@/view/llmConfg/component/LlmProviderSettingForm";
import {formatIsoReadable} from "@/utils/dateUtils";
import {cn} from "@/lib/utils";

const LlmConfigView: React.FC = () => {
    const {data: llmConfig} = useLlmConfig()
    const [selectedProvider, setSelectedProvider] = useState<LlmConfig>();

    useEffect(() => {
        if (!llmConfig)
            return;

        setSelectedProvider((prev) =>
            llmConfig.find((c) => c.provider === prev?.provider) ?? llmConfig[0]
        );
    }, [llmConfig]);

    return (
        <div className="w-full h-full flex flex-col gap-5 p-5">
            <div className="h-[100px] rounded-xl border border-red-400 bg-red-100 p-5 space-y-3">
                <p className="text-red-500">Danger Zone</p>
                <p className="text-sm">이 설정을 변경하면 해당 LLM을 사용 중인 Workflow에 영향을 줍니다. 변경 전 반드시 확인하세요.</p>
            </div>
            <div className="flex gap-5">
                <div className="w-[35%] flex flex-col gap-2">
                    {llmConfig?.map((config: LlmConfig) => {
                            return (
                                <div key={config.provider}
                                     className={cn("flex flex-col gap-2 border border-gray-400 rounded-lg p-4 cursor-pointer hover:bg-gray-200",
                                         selectedProvider?.provider === config.provider && "bg-gray-300",
                                     )}
                                     onClick={() => setSelectedProvider(config)}
                                >
                                    <ProviderContent llmConfig={config}/>
                                </div>
                            )
                        }
                    )}
                </div>
                <div className="flex flex-1">
                    {selectedProvider && (
                        <LlmProviderSettingForm key={selectedProvider.provider}
                                                llmConfig={selectedProvider} />
                    )}
                </div>
            </div>
        </div>
    )
}

type ProviderContentProps = {
    llmConfig: LlmConfig;
}

const ProviderContent: React.FC<ProviderContentProps> = (props) => {
    const {llmConfig} = props
    return (
        <div className="flex flex-col gap-5">
            <div className="flex justify-between">
                <div className="font-bold text-md">
                    {llmConfig.provider}
                </div>
                <div className="font-bold text-sm">
                    모델 {llmConfig.models.length} 개
                </div>
            </div>
            <div className="flex flex-col gap-2">
                <div className="text-xs">
                    최근 수정 일자 : {formatIsoReadable(llmConfig.updatedAt)}
                </div>
            </div>
        </div>
    )
}

export default LlmConfigView;